window.codeFormatter = function(value, row) {
    return '<code>' + value + '</code>';
};
